import { createFileRoute, redirect } from '@tanstack/react-router'
import qs from 'qs'
import validateAppDest from '@/common/lib/validateAppDest'
import isAbsoluteUrl from '@/common/lib/isAbsoluteUrl'
import PageLogin from '@/pages/account/login'

export const Route = createFileRoute('/app/account/login')({
  beforeLoad: ({ context, location }) => {
    if (context.currentUser?.isAuthenticated) {
      const params = qs.parse(location.searchStr, { ignoreQueryPrefix: true })
      let redirectTo = '/app/account/dashboard'
      if (params.appDest && validateAppDest(String(params.appDest))) {
        redirectTo = String(params.appDest)
      } else if (params.from && validateAppDest(String(params.from))) {
        redirectTo = String(params.from)
      }
      if (isAbsoluteUrl(redirectTo)) {
        window.location.href = redirectTo
        return
      }
      throw redirect({ to: redirectTo })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PageLogin />
}
